module.exports = __webpack_public_path__ + "static/media/portos.e469de49.png";